export default __webpack_public_path__ + "static/media/anita200x200.29367507.png";